<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9597 4.14461C12.1599 3.66338 12.8416 3.66338 13.0418 4.14461L15.2563 9.46905C15.3407 9.67192 15.5315 9.81053 15.7505 9.82809L21.4987 10.2889C22.0182 10.3306 22.2289 10.9789 21.833 11.318L17.4535 15.0695C17.2867 15.2124 17.2138 15.4367 17.2648 15.6504L18.6028 21.2597C18.7237 21.7666 18.1722 22.1673 17.7274 21.8957L12.8062 18.8898C12.6187 18.7753 12.3828 18.7753 12.1953 18.8898L7.2741 21.8957C6.82931 22.1673 6.2778 21.7666 6.39873 21.2597L7.73674 15.6504C7.78772 15.4367 7.71484 15.2124 7.54797 15.0695L3.16847 11.318C2.77265 10.9789 2.98331 10.3306 3.50283 10.2889L9.25101 9.82809C9.47003 9.81053 9.66081 9.67192 9.74519 9.46905L11.9597 4.14461Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgStarEmpty',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>